var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 220,
    viewBox: "0 0 240 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_d_21_6102)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 120,
    cy: 88,
    r: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.861 89.7531L128.837 89.7419C128.378 89.5457 127.878 89.467 127.381 89.5129C126.885 89.5587 126.407 89.7276 125.993 90.0044C125.944 90.0366 125.897 90.0717 125.852 90.1094L121.288 94C118.397 92.5956 115.412 89.6331 114.008 86.7794L117.904 82.1462C117.941 82.0994 117.977 82.0525 118.011 82.0019C118.281 81.5881 118.446 81.1137 118.489 80.6211C118.532 80.1284 118.453 79.6327 118.258 79.1781V79.1556L114.289 70.3075C114.031 69.7136 113.589 69.2189 113.027 68.8972C112.466 68.5755 111.815 68.444 111.173 68.5225C108.632 68.8568 106.3 70.1046 104.612 72.0327C102.924 73.9608 101.995 76.4374 102 79C102 93.8875 114.113 106 129 106C131.563 106.005 134.039 105.076 135.967 103.388C137.895 101.7 139.143 99.3682 139.478 96.8275C139.556 96.1852 139.425 95.5348 139.104 94.9732C138.782 94.4116 138.288 93.9689 137.694 93.7112L128.861 89.7531ZM112.037 95.9629C107.538 91.4635 105.007 85.363 105 79C104.993 77.169 105.653 75.3981 106.856 74.0179C108.059 72.6378 109.723 71.7427 111.538 71.5C111.537 71.5075 111.537 71.515 111.538 71.5225L115.476 80.335L111.6 84.9737C111.561 85.019 111.525 85.0673 111.493 85.1181C111.211 85.5511 111.045 86.0496 111.013 86.5654C110.98 87.0811 111.081 87.5966 111.306 88.0619C113.004 91.5362 116.505 95.0106 120.017 96.7075C120.486 96.9303 121.004 97.0278 121.522 96.9903C122.039 96.9528 122.538 96.7817 122.97 96.4937C123.018 96.4613 123.064 96.4263 123.109 96.3887L127.667 92.5L136.479 96.4469C136.479 96.4469 136.494 96.4469 136.5 96.4469C136.26 98.2642 135.367 99.932 133.986 101.138C132.606 102.344 130.833 103.006 129 103C122.637 102.993 116.536 100.462 112.037 95.9629Z",
    fill: "#E7454C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_6102",
    x: 0,
    y: -20,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_6102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_6102",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.774f7a8bb51f27d4082fd872c08c9be4.svg";
export { ForwardRef as ReactComponent };